/* src/app/components/Sidebar/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { map, isEmpty } from 'lodash';

import { NavLink } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import {
  Avatar,
  Divider,
  Drawer,
  FormControl,
  IconButton,
  Input, InputLabel,
  List, ListItem, ListItemAvatar, ListItemIcon, ListItemText,
  MenuItem,
  Select,
} from '@material-ui/core';
import { ChevronLeft } from '@material-ui/icons';

import routes from '../../routes';
import { smallScreen } from '../../../config/constants/styles';
import styles from './styles';
import { loadTexts } from '../../../config/texts';

import { selectUniversity, selectOrganization } from '../../../modules/auth/actions';

import Stripe from '../../../util/stripe';
const TEXT_KEY = 'sidebar';

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      texts: loadTexts(TEXT_KEY, props.locale)
    };
    this._onChangeUniversity = this._onChangeUniversity.bind(this);
    this._onChangeOrganization = this._onChangeOrganization.bind(this);
    this.sidebarRoutes = routes.filter(r => !r.omit);
  }

  componentWillMount() {
    const { universities, organizations } = this.props;
    if (!isEmpty(universities)) this.props.selectUniversity(universities[0]._id);
    if (!isEmpty(organizations)) this.props.selectOrganization(organizations[0]._id);
  }

  _onChangeUniversity(event) {
    this.props.selectUniversity(event.target.value);
  }

  _onChangeOrganization(event) {
    // update stripe here
    const newOrg = event.target.value;
    this.props.selectOrganization(newOrg);

    // find organization
    const org = this.props.organizations.find(o => o._id === newOrg);
    Stripe.updateCurrency(org.currency || 'cad');
  }

  renderToolbar() {
    const { onClose, classes } = this.props;
    return (
      <div className={classes.toolbar}>
        {smallScreen && (
          <IconButton onClick={onClose}>
            <ChevronLeft />
          </IconButton>
        )}
      </div>
    );
  }

  renderUser() {
    // const { classes, user: { user: { first, last, avatar } }, match } = this.props;
    return this.renderSelects();
    // return (
    //   <div>
    //     <NavLink
    //       to={`${match.url}/profile`}
    //       activeStyle={{ backgroundColor: '#e0e0e0' }}
    //       className={classes.item}
    //     >
    //       <ListItem dense button className={classes.listItem}>
    //         <ListItemAvatar>
    //           <Avatar alt="avatar" src={avatar}>
    //             {!avatar && `${first[0]}${last[0]}`}
    //           </Avatar>
    //         </ListItemAvatar>
    //         <ListItemText primary={`${first} ${last}`} />
    //       </ListItem>
    //     </NavLink>
    //     {this.renderSelects()}
    //   </div>
    // );
  }

  renderSelects() {
    const {
      classes,
      user: { universities, organizations },
      selectedUniversity,
      selectedOrganization,
    } = this.props;
    const { texts } = this.state;
    return (
      <div className={classes.selects}>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="Institution">{texts.institution}</InputLabel>
          <Select
            classes={{ root: classes.universitySelect }}
            value={selectedUniversity}
            onChange={this._onChangeUniversity}
            input={<Input name="Institution" id="Institution" />}
            MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
          >
            {/* }<MenuItem value="all">
              <em>All</em>
            </MenuItem> */}
            {map(universities, u => (
              <MenuItem key={u._id} value={u._id}>{u.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="organization">{texts.organization}</InputLabel>
          <Select
            value={selectedOrganization}
            onChange={this._onChangeOrganization}
            input={<Input name="organization" id="organization" />}
            MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
          >
            {/* }<MenuItem value="all">
              <em>All</em>
            </MenuItem> */}
            {map(organizations, o => (
              <MenuItem key={o._id} value={o._id}>{o.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }

  renderOptions() {
    const { classes, match } = this.props;
    return (
      <div>
        <List>
          {this.sidebarRoutes.map(({ path, text, icon: Icon }) => (
            <NavLink
              to={`${match.url}${path}`}
              className={classes.item}
              activeStyle={{ backgroundColor: '#e0e0e0' }}
              key={text}
            >
              <ListItem dense button className={classes.active}>
                <ListItemIcon>
                  <Icon />
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            </NavLink>
          ))}
        </List>
      </div>
    );
  }

  render() {
    const { open } = this.props;
    return (
      <Drawer
        variant={smallScreen ? 'temporary' : 'persistent'}
        open={open}
      >
        {this.renderToolbar()}
        <Divider />
        {this.renderUser()}
        <Divider />
        {this.renderOptions()}
      </Drawer>
    );
  }
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  selectUniversity: PropTypes.func.isRequired,
  selectOrganization: PropTypes.func.isRequired,
  selectedUniversity: PropTypes.string.isRequired,
  selectedOrganization: PropTypes.string.isRequired,
  universities: PropTypes.array.isRequired,
  organizations: PropTypes.array.isRequired,
};

const mapStateToProps = state => {
  const {
    auth: {
      data: { user },
      selectedUniversity,
      selectedOrganization,
    },
    appState: {
      locale
    }
   } = state;
  return {
    user,
    selectedUniversity,
    selectedOrganization,
    organizations: user.organizations,
    universities: user.universities,
    locale,
  };
};

const mapDispatchToProps = { selectUniversity, selectOrganization };

export default compose(
  withStyles(styles, { name: 'Sidebar' }),
  connect(mapStateToProps, mapDispatchToProps)
)(Sidebar);



// WEBPACK FOOTER //
// ./src/app/components/Sidebar/index.js